const state = {
  wallet: null,
  historyUrl: null,
  beforeUrl: null,
  newWalletUrl: null,
  mnemonic: '',
  balance: null,
  offline: null,
  mode: true
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js